import React from "react"

export default function CompetitionTabHeader({ title, children }) {
  return <header className="competition-tab-header">
    <h2 className="competition-tab-title">{title}</h2>
    {children && <div className="competition-tab-header-actions">{children}</div>}
  </header>
}
